import { z } from 'zod';

export const ComponentHealthSchema = z.object({
  status: z.enum(['up', 'down']),
  latencyMs: z.number().nonnegative().optional(),
  message: z.string().optional(),
});
export type ComponentHealth = z.infer<typeof ComponentHealthSchema>;

/**
 * `/health/live` answers "is the process alive?" and must never touch a
 * dependency — a liveness probe that fails when the database blips would
 * restart a healthy process and turn a brief outage into a crash loop.
 */
export const LivenessSchema = z.object({
  status: z.literal('ok'),
  uptimeSeconds: z.number().nonnegative(),
  version: z.string(),
});
export type Liveness = z.infer<typeof LivenessSchema>;

/** `/health/ready` answers "can this instance serve traffic?" and does check them. */
export const ReadinessSchema = z.object({
  status: z.enum(['ok', 'degraded', 'down']),
  version: z.string(),
  checks: z.record(ComponentHealthSchema),
});
export type Readiness = z.infer<typeof ReadinessSchema>;
